import Seo from 'gatsby-plugin-wpgraphql-seo';
import React, { useContext } from 'react';
import Helmet from 'react-helmet';

import LanguageContext from '../../context/LanguageContext';
import { getLangMetas } from './utils';

export interface IMetaLanguage {
  href: string;
  hrefLang: LanguageCode | 'x-default';
  rel: 'alternate';
}

export interface ISEOProps {
  pageData: {
    seo: Queries.PageDAccueilQuery['wpPage']['seo'];
    translations: Queries.PageDAccueilQuery['wpPage']['translations'];
    link: Queries.PageDAccueilQuery['wpPage']['link'];
    language: Queries.PageDAccueilQuery['wpPage']['language'];
  };
}

const SEO: FCWithClassName<ISEOProps> = (props) => {
  const { pageData } = props;
  if (!pageData.seo) return null;
  const { defaultLanguage } = useContext(LanguageContext);
  const pageDataWithFormattedTitle = {
    ...pageData,
    seo: { ...pageData.seo, title: pageData.seo.title.replace('&ndash;', '-') },
  };
  const langMetas = defaultLanguage
    ? getLangMetas({
        defaultLocale: defaultLanguage?.locale,
        pageData,
        siteUrl: process.env.GATSBY_WEBSITE_URL,
      })
    : undefined;

  //console.log('SEO : ', pageData);

  return (
    <React.Fragment>
      <Seo post={pageDataWithFormattedTitle} />
      <Helmet
        htmlAttributes={{
          lang: pageData.language?.slug,
        }}
        {...(langMetas ? { link: langMetas } : {})}
      >
        {pageData.seo.canonical && (
          <link
            rel="canonical"
            href={process.env.GATSBY_WEBSITE_URL + pageData.seo.canonical}
          />
        )}

        {/* Based on translations, add alternates */}
        {pageData.translations?.map((translation) => (
          <link
            key={translation.language.locale}
            rel="alternate"
            href={process.env.GATSBY_WEBSITE_URL + translation.uri}
            hrefLang={translation.language.locale}
          />
        ))}
      </Helmet>
    </React.Fragment>
  );
};

export default SEO;
